// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3TQC6","clinicsSelect":"TableHeading_clinicsSelect__2Z5or"};